module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst img = helpers.detectRenderedImage(model.logo, model._logo) || {}\n%><div><%\n%><div class=\"content\"><%\n%><div class=\"logo\"><%\nif (img.url) {\n%><img src=\"<%- img.url %>\" alt=\"Logo\" /><%\n}\n%></div><%\n%></div><%\n%></div>"
  , __filename = "components/templates/core/static/header/header.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const img = helpers.detectRenderedImage(model.logo, model._logo) || {}

    ; __line = 3
    ; __append("<div>")
    ; 

    ; __line = 4
    ; __append("<div class=\"content\">")
    ; 

    ; __line = 5
    ; __append("<div class=\"logo\">")
    ; 
if (img.url) {

    ; __line = 7
    ; __append("<img src=\"")
    ; __append( img.url )
    ; __append("\" alt=\"Logo\" />")
    ; 
}

    ; __line = 9
    ; __append("</div>")
    ; 

    ; __line = 10
    ; __append("</div>")
    ; 

    ; __line = 11
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/static/header/header.ejs

}